import React from 'react';
import cn from 'classnames';
import * as styles from './Notice.module.scss';

export default function Notice({ children, className }) {
  return <div className={cn(styles.notice, className)}>{children}</div>;
}
